module.exports = __webpack_public_path__ + "img/1-35-5.73d4a1ef.png";